const udaipurItinerary = {
  slug:"udaipur",
  title: "Udaipur Romantic Escape",
  duration: "4 days",
  location: "Udaipur, Rajasthan, India",
  difficulty: "Easy",
  priceRange: "$$ (Comfort)",
  bestTime: "October to March",
  description:
    "A romantic getaway in the City of Lakes, featuring royal palaces, sunset boat rides, heritage hotels, and serene lake views.",
  highlights: [
    "Lake Pichola boat ride",
    "City Palace complex",
    "Jag Mandir & Lake Palace views",
    "Sunset at Sajjangarh (Monsoon Palace)",
    "Romantic lakeside dining"
  ],
  image:
    "https://images.unsplash.com/photo-1599661046289-e31897846e41",

  days: [
    {
      day: 1,
      title: "Arrival & Lakeside Evening",
      places: [
        "Maharana Pratap Airport, Udaipur",
        "Lake Pichola",
        "Bagore Ki Haveli"
      ],
      activities: [
        "Arrival in Udaipur",
        "Hotel check-in",
        "Evening boat ride on Lake Pichola",
        "Cultural dance show at Bagore Ki Haveli"
      ],
      accommodation: "Udaipur hotel / heritage stay",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "Udaipur City Tour",
      places: [
        "City Palace, Udaipur",
        "Jagdish Temple",
        "Saheliyon Ki Bari",
        "Fateh Sagar Lake"
      ],
      activities: [
        "Explore City Palace complex",
        "Visit Jagdish Temple",
        "Stroll through Saheliyon Ki Bari",
        "Evening at Fateh Sagar Lake"
      ],
      accommodation: "Udaipur hotel",
      meals: "Breakfast included"
    },
    {
      day: 3,
      title: "Sunset & Leisure",
      places: [
        "Sajjangarh Monsoon Palace",
        "Jag Mandir",
        "Old City Udaipur"
      ],
      activities: [
        "Leisure morning",
        "Visit Sajjangarh Monsoon Palace for sunset",
        "Optional Jag Mandir visit",
        "Romantic rooftop dinner"
      ],
      accommodation: "Udaipur hotel",
      meals: "Breakfast included"
    },
    {
      day: 4,
      title: "Departure",
      places: [
        "Old City Udaipur",
        "Maharana Pratap Airport"
      ],
      activities: [
        "Morning shopping for handicrafts",
        "Hotel check-out",
        "Airport transfer",
        "Departure"
      ],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "3 nights accommodation",
    "Daily breakfast",
    "Lake Pichola boat ride",
    "All local sightseeing transfers"
  ],

  exclusions: [
    "Flights",
    "Travel insurance",
    "Lunches and dinners",
    "Personal expenses"
  ],

  tips: [
    "Book lake-view hotels early",
    "Best sunsets from Monsoon Palace",
    "Carry light woolens in winter",
    "Try local Rajasthani thali"
  ],

  budget: {
    flights: "$100–200 (domestic)",
    accommodation: "$60–150/night",
    food: "$15–30/day",
    transport: "$15–25/day",
    total: "$400–800 per person"
  }
};

export default udaipurItinerary;
